var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('object-details-template',{attrs:{"place-preview":_vm.placePreview,"is-modal-children":_vm.isModalChildren},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('object-header')]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }